import consentTexts from "./consent-texts.json";

export function getLocalizedRequiredConsentTexts(t) {
  return {
    ...consentTexts,
    acceptTermsPrivacy: {
      ...consentTexts.acceptTermsPrivacy,
      label: t("required_consent_terms_privacy_label", {
        defaultValue:
          "I have read and agree to the Terms and Conditions and Privacy Policy.",
      }),
      labelParts: {
        beforeTerms: t("required_consent_terms_privacy_before_terms", {
          defaultValue: "I have read and agree to the ",
        }),
        termsLabel: t("required_consent_terms_label", {
          defaultValue: "Terms and Conditions",
        }),
        betweenLinks: t("required_consent_terms_privacy_between_links", {
          defaultValue: " and ",
        }),
        privacyLabel: t("required_consent_privacy_label", {
          defaultValue: "Privacy Policy",
        }),
        afterPrivacy: t("required_consent_terms_privacy_after_privacy", {
          defaultValue: ".",
        }),
      },
      error: t("required_consent_terms_privacy_error", {
        defaultValue: "You must accept the Terms and Privacy Policy to continue.",
      }),
      helper: t("required_consent_terms_privacy_helper", {
        defaultValue:
          "By creating an account, you confirm that you have read and accepted our Terms and Conditions and Privacy Policy.",
      }),
    },
    acceptProfileVisibility: {
      ...consentTexts.acceptProfileVisibility,
      label: t("required_consent_profile_visibility_label", {
        defaultValue:
          "I understand that some profile information, posts, catches, comments, and social activity may be visible to other users depending on how I use the app.",
      }),
      error: t("required_consent_profile_visibility_error", {
        defaultValue:
          "Please confirm that you understand profile and content visibility.",
      }),
      helper: t("required_consent_profile_visibility_helper", {
        defaultValue:
          "Reel it like a PRO includes public and social features. Information you choose to add to your profile or share through posts, catches, groups, comments, and social activity may be visible to other users.",
      }),
    },
  };
}
